import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const login = async (loginData) => {
  const response = await axios.post(`${API_URL}login`, loginData, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
  return response.data;
};

const logout = async () => {
  const token = sessionStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}logout`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export default {
  login,
  logout,
};